import { MERCATELY_API } from '../../constants/AppConstants';
import abstractModel from '../../core/MercatelyModel';

const resource = `${MERCATELY_API}/customers`;

const model = abstractModel(resource);

model.fetchCustomerTopics = async ({ customerId, channel, page }) => {
  const newResource = `${resource}/${customerId}/conversation_topics?channel=${channel}&page=${page}`;
  return model.get({}, { path: newResource });
};

model.deleteCustomerTopic = async ({ customerId, topicId }) => {
  const newResource = `${resource}/${customerId}/conversation_topics/${topicId}`;
  return model.remove({}, { path: newResource });
};

model.assignCustomerTopic = async (params) => {
  const newResource = `${resource}/${params.customerId}/conversation_topics`;
  return model.save(params, { path: newResource });
};

model.editTopic = async (params) => model.save(params);

export default model;
